import React from 'react'

const RadioButton = ({ classStyles, btnName, handleClick, cancelBg }) => (
    <button type="button" className={classStyles} onClick={() => handleClick()}>
        {btnName}
    </button>
)

export default RadioButton
